import { z } from 'zod';
export const riskSupportingKindSchema = z.enum(['riskAssessments_adhoc', 'riskParticipants', 'riskProposals', 'riskRoundSummary']);
export const riskSupportingViewSchema = z.object({
    archiveId: z.string().regex(/^support-[a-f0-9]{48}$/u), kind: riskSupportingKindSchema,
    title: z.string().max(1_000), company: z.string().max(300), round: z.string().max(100),
    fields: z.array(z.object({ label: z.string().max(100), value: z.string().max(10_000) }).strict()).max(30),
    rows: z.array(z.object({ label: z.string().max(300), value: z.string().max(10_000) }).strict()).max(300),
    notice: z.string().max(1_000),
}).strict();
export const riskSupportingPageSchema = z.object({ items: z.array(riskSupportingViewSchema).max(30),
    heldCount: z.number().int().min(0).max(30).optional(),
    nextCursor: z.string().regex(/^support-[a-f0-9]{48}$/u).nullable() }).strict();
